<template>
  <div :class="['header', white ? 'white' : '']" :style="{ 'padding-top': statusBar + 'px' }">
    <div class="left" @click="goback(save)">
      <img v-if="back && !white" src="@/assets/image/1.png" alt="">
      <img v-if="back && white" src="@/assets/image/13.png" alt="">
      <span></span>
    </div>
    <p class="center">{{ title }}</p>
    <div class="right" @click="rightC()">
      <span v-if="right">{{ right }}</span>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  name: "Header",
  props: {
    save: Boolean,
    title: String,
    back: Boolean,
    left: String,
    right: String,
    white: Boolean,
    backnum: Number,
    backInitHome: Boolean,
  },
  data() {
    return {
      statusBar: 0,
    };
  },
  mounted() {
    this.statusBar = sessionStorage.getItem("statusBar")
      ? sessionStorage.getItem("statusBar")
      : 0;
  },
  methods: {
    /**
     * 右边点击
     */
    rightC() {
      this.$emit("rightC");
    },
    /**
     * 返回
     */
    goback(save) {
      if (save) {
        Dialog.confirm({
          message: "您填写的内容未提交，确定离开吗？",
          theme: "round-button",
        })
          .then(() => {
            if (this.backInitHome) {
              this.$emit("leftC");
            } else {
              if (this.backnum) {
                this.$router.go(-this.backnum);
              } else {
                this.$router.go(-1);
              }
            }
          })
          .catch(() => {
            Dialog.close();
          });
      } else {
        if (this.backInitHome) {
          this.$emit("leftC");
        } else {
          if (this.backnum) {
            this.$router.go(-this.backnum);
          } else {
            this.$router.go(-1);
          }
        }
      }
    },
  },
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  background: $themColor1;
  width: 100%;
  color: #fff;
  display: flex;
  flex-direction: row;
  position: fixed;
  top: 0;
  z-index: 100;

  .left {
    width: 65px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 15px;

    img {
      height: 16px;
      margin-left: 8px;
    }
  }

  .center {
    flex: 1;
    font-size: 16px;
    display: flex;
    font-weight: bold;
    justify-content: center;
    align-items: center;
    height: 44px;
  }

  .right {
    width: 65px;
    display: flex;
    font-size: 15px;
    justify-content: flex-end;
    align-items: center;

    span {
      margin-right: 12px;
    }
  }

  &.white {
    background: #fff;
    border-bottom: 1px solid $lineColor;

    .left {
      color: $themColor1;
    }

    .center {
      color: $fontColor;
      font-weight: bold;
    }

    .right {
      color: $fontColor;
    }
  }
}
</style>